import { apiClient } from './client';

export interface Hashtag {
  id: string;
  tag: string;
  storyCount: number;
  count?: number; // for trending
}

export const hashtagsApi = {
  async trending(limit = 20): Promise<Hashtag[]> {
    const res = await apiClient.get('/api/hashtags/trending', { params: { limit } });
    return res.data.items;
  },

  async search(q: string, limit = 10): Promise<Hashtag[]> {
    const res = await apiClient.get('/api/hashtags/search', { params: { q, limit } });
    return res.data.items;
  },

  async byTag(tag: string, cursor?: string) {
    const res = await apiClient.get(`/api/hashtags/${encodeURIComponent(tag)}`, { params: { cursor } });
    return res.data as { tag: string; storyCount: number; stories: unknown[]; nextCursor: string | null };
  },
};
